module.exports = __webpack_public_path__ + "static/media/spinLoading.54154f11.gif";